// Generated by tools/audio/build_native_combat_sound_cues.mjs.
// Source-authored MOTION/M_FGT1 frame cues; do not edit by hand.
export const NATIVE_COMBAT_SOUND_CUES = Object.freeze({
  "schema": "new-yokosuka-native-combat-sound-cues-v1",
  "soundBank": {
    "source": "extracted_disc3_v2/data/SCENE/03/SOUND/BATTLE_1.SND",
    "byteLength": 284444,
    "sha256": "3c07c03c9828edcc9af787aa5e74062c0cc09460ff7af34285fe3689ccd57658",
    "validCommandPrefixes": [
      "ab76",
      "ab77"
    ],
    "playableCommandCount": 70
  },
  "banks": {
    "global": {
      "source": "extracted_disc3_v2/data/MOTION/MOTION.BIN",
      "byteLength": 1826800,
      "sha256": "512abe68b26a2a8bf78c8011b54faf01f9c3e0ce3e4d0b56491161eec3565dec",
      "sequences": {
        "AKIRA_BPK_MISS": [
          {
            "frame": 3,
            "commandHex": "ab760900"
          }
        ],
        "AKIRA_KI_00_13": [
          {
            "frame": 5,
            "commandHex": "ab761f00"
          }
        ],
        "AKIRA_KI_01": [
          {
            "frame": 4,
            "commandHex": "ab761f00"
          }
        ],
        "AKIRA_PU_00_VF3": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "AKIRA_PU_01_VF3": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "AKIRA_PU_SAFE": [
          {
            "frame": 6,
            "commandHex": "ab761700"
          }
        ],
        "AKIRA_SY_KI_SYO_L_VF3": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "AKIRA_TA_KI_LOW_VF3": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "AKIRA_TA_PU_MOUKO": [
          {
            "frame": 6,
            "commandHex": "ab761700"
          },
          {
            "frame": 6,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_RUN_JUMP": [
          {
            "frame": 11,
            "commandHex": "ab760900"
          },
          {
            "frame": 28,
            "commandHex": "ab762a00"
          }
        ],
        "AKI_JUMP": [
          {
            "frame": 11,
            "commandHex": "ab760900"
          },
          {
            "frame": 28,
            "commandHex": "ab762a00"
          }
        ],
        "AKI_RUN_JUMP": [
          {
            "frame": 12,
            "commandHex": "ab760900"
          },
          {
            "frame": 24,
            "commandHex": "ab762a00"
          }
        ],
        "AKI_AKI_KICK_KKT_S1_2": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "AK_BACK_NA": [
          {
            "frame": 4,
            "commandHex": "ab761700"
          },
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "AK_BACK_YA": [
          {
            "frame": 7,
            "commandHex": "ab760200"
          },
          {
            "frame": 22,
            "commandHex": "ab762600"
          }
        ],
        "AK_DW_TA_KI_00": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "AK_FB_CHG_ACT": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "AK_FB_CHG_YA_SK": [
          {
            "frame": 1,
            "commandHex": "ab761b00"
          }
        ],
        "AK_GU_HAZUSHI": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "AK_GU_HAZUSHI_MDL": [
          {
            "frame": 7,
            "commandHex": "ab761900"
          }
        ],
        "AK_HIZA_KAE_L_NA": [
          {
            "frame": 7,
            "commandHex": "ab762900"
          },
          {
            "frame": 16,
            "commandHex": "ab760800"
          },
          {
            "frame": 16,
            "commandHex": "ab760c00"
          }
        ],
        "AK_HIZA_KAE_L_YA": [
          {
            "frame": 13,
            "commandHex": "ab762600"
          }
        ],
        "AK_HIZA_KAE_R_NA": [
          {
            "frame": 7,
            "commandHex": "ab762900"
          },
          {
            "frame": 16,
            "commandHex": "ab760800"
          },
          {
            "frame": 16,
            "commandHex": "ab760c00"
          }
        ],
        "AK_HIZA_KAE_R_YA": [
          {
            "frame": 13,
            "commandHex": "ab762600"
          }
        ],
        "AK_KATA_ATK": [
          {
            "frame": 4,
            "commandHex": "ab761700"
          }
        ],
        "AK_KATA_MATA_YA_AN": [
          {
            "frame": 17,
            "commandHex": "ab760000"
          },
          {
            "frame": 24,
            "commandHex": "ab760200"
          },
          {
            "frame": 55,
            "commandHex": "ab762600"
          }
        ],
        "AK_KOUTEN_KI_00": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "AK_KOUTEN_KI_01": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "AK_KOUTEN_KI_10": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "AK_KOUTEN_KI_11": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "AK_OUTEN_KI_00": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "AK_OUTEN_KI_00_M": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "AK_OUTEN_KI_01": [
          {
            "frame": 9,
            "commandHex": "ab761a00"
          }
        ],
        "AK_OUTEN_KI_01_M": [
          {
            "frame": 9,
            "commandHex": "ab761a00"
          }
        ],
        "AK_OUTEN_KI_02": [
          {
            "frame": 9,
            "commandHex": "ab761a00"
          }
        ],
        "AK_RUF_501_02": [
          {
            "frame": 11,
            "commandHex": "ab761a00"
          }
        ],
        "AK_RUF_511_02": [
          {
            "frame": 11,
            "commandHex": "ab761a00"
          }
        ],
        "AK_RUF_521_02": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "AK_RUF_531_02": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "AK_RUF_541_02": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "AK_RUF_551_02": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "AK_RUF_561_02": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "AK_RUF_571_02": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "AK_SOSO_KAE_L_NA": [
          {
            "frame": 5,
            "commandHex": "ab762900"
          },
          {
            "frame": 8,
            "commandHex": "ab760800"
          },
          {
            "frame": 8,
            "commandHex": "ab760c00"
          }
        ],
        "AK_SOSO_KAE_L_YA": [
          {
            "frame": 15,
            "commandHex": "ab762600"
          }
        ],
        "AK_SOSO_KAE_R_NA": [
          {
            "frame": 5,
            "commandHex": "ab762900"
          },
          {
            "frame": 8,
            "commandHex": "ab760800"
          },
          {
            "frame": 8,
            "commandHex": "ab760c00"
          }
        ],
        "AK_SOSO_KAE_R_YA": [
          {
            "frame": 15,
            "commandHex": "ab762600"
          }
        ],
        "AK_SOUKA_HOU": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "AK_SOUSYOU": [
          {
            "frame": 4,
            "commandHex": "ab760900"
          },
          {
            "frame": 6,
            "commandHex": "ab761700"
          }
        ],
        "AK_TA_B_00_NEW_TSU": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "AK_TA_F_00": [
          {
            "frame": 3,
            "commandHex": "ab760900"
          }
        ],
        "AK_UKASHI_NA": [
          {
            "frame": 1,
            "commandHex": "ab761b00"
          }
        ],
        "AK_UKASHI_YA": [
          {
            "frame": 10,
            "commandHex": "ab760100"
          },
          {
            "frame": 25,
            "commandHex": "ab762600"
          }
        ],
        "AK_YOKO_NAGE_L_NA": [
          {
            "frame": 13,
            "commandHex": "ab760c00"
          },
          {
            "frame": 13,
            "commandHex": "ab760300"
          }
        ],
        "AK_YOKO_NAGE_L_YA": [
          {
            "frame": 22,
            "commandHex": "ab762600"
          }
        ],
        "AK_YOKO_NAGE_R_NA": [
          {
            "frame": 13,
            "commandHex": "ab760c00"
          },
          {
            "frame": 13,
            "commandHex": "ab760300"
          }
        ],
        "AK_YOKO_NAGE_R_YA": [
          {
            "frame": 22,
            "commandHex": "ab762600"
          }
        ],
        "ARPD_145_NA_WA": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "ARPD_145_RARI": [
          {
            "frame": 10,
            "commandHex": "ab762700"
          }
        ],
        "ARPD_145_YA_WA": [
          {
            "frame": 18,
            "commandHex": "ab762600"
          }
        ],
        "ARPD_151": [
          {
            "frame": 12,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_URAKEN_ROLL_TOP_R": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "BA_00": [
          {
            "frame": 6,
            "commandHex": "ab761700"
          }
        ],
        "BA_02_N_WA": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "BA_02_Y_WA": [
          {
            "frame": 17,
            "commandHex": "ab760000"
          },
          {
            "frame": 38,
            "commandHex": "ab762600"
          }
        ],
        "BA_03_N_WA": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "BA_03_VF2_YA": [
          {
            "frame": 15,
            "commandHex": "ab762600"
          }
        ],
        "BA_03_Y_WA": [
          {
            "frame": 13,
            "commandHex": "ab760000"
          }
        ],
        "DW_KOUTEN_KI_10": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "DW_KOUTEN_KI_12": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "DW_TA_KI_00": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "DW_TA_SKI_00": [
          {
            "frame": 19,
            "commandHex": "ab762700"
          }
        ],
        "JFKD_031": [
          {
            "frame": 14,
            "commandHex": "ab762700"
          },
          {
            "frame": 22,
            "commandHex": "ab762700"
          }
        ],
        "JFKD_075": [
          {
            "frame": 11,
            "commandHex": "ab762700"
          }
        ],
        "JU_KI_SYO_M": [
          {
            "frame": 1,
            "commandHex": "ab761a00"
          }
        ],
        "KABE_AK_BA_NA": [
          {
            "frame": 1,
            "commandHex": "ab761b00"
          },
          {
            "frame": 26,
            "commandHex": "ab761b00"
          }
        ],
        "KABE_AK_BA_YA": [
          {
            "frame": 28,
            "commandHex": "ab761700"
          },
          {
            "frame": 29,
            "commandHex": "ab760d00"
          },
          {
            "frame": 29,
            "commandHex": "ab760200"
          },
          {
            "frame": 30,
            "commandHex": "ab760300"
          },
          {
            "frame": 49,
            "commandHex": "ab762600"
          }
        ],
        "KAESHI00_ACT_L": [
          {
            "frame": 8,
            "commandHex": "ab762900"
          },
          {
            "frame": 15,
            "commandHex": "ab760c00"
          },
          {
            "frame": 15,
            "commandHex": "ab760800"
          }
        ],
        "KAESHI00_ACT_MIR_L": [
          {
            "frame": 8,
            "commandHex": "ab762900"
          },
          {
            "frame": 15,
            "commandHex": "ab760c00"
          },
          {
            "frame": 15,
            "commandHex": "ab760800"
          }
        ],
        "KAESHI00_YA": [
          {
            "frame": 15,
            "commandHex": "ab762600"
          }
        ],
        "KAESHI00_YA_M_TSU": [
          {
            "frame": 15,
            "commandHex": "ab762600"
          }
        ],
        "KAESHI01_ACT_M_L": [
          {
            "frame": 7,
            "commandHex": "ab762900"
          },
          {
            "frame": 14,
            "commandHex": "ab761700"
          },
          {
            "frame": 15,
            "commandHex": "ab760200"
          }
        ],
        "KAESHI01_YA_M_TSU": [
          {
            "frame": 21,
            "commandHex": "ab762600"
          }
        ],
        "KAESHI_HG_ACT_L": [
          {
            "frame": 10,
            "commandHex": "ab762900"
          },
          {
            "frame": 17,
            "commandHex": "ab760c00"
          },
          {
            "frame": 17,
            "commandHex": "ab760800"
          }
        ],
        "KAESHI_HG_YA": [
          {
            "frame": 19,
            "commandHex": "ab762600"
          }
        ],
        "K_KES_HKS_ACT_M_L": [
          {
            "frame": 8,
            "commandHex": "ab762900"
          },
          {
            "frame": 14,
            "commandHex": "ab761700"
          },
          {
            "frame": 15,
            "commandHex": "ab760c00"
          },
          {
            "frame": 15,
            "commandHex": "ab760800"
          }
        ],
        "K_KES_HKS_NA_L": [
          {
            "frame": 8,
            "commandHex": "ab762900"
          },
          {
            "frame": 14,
            "commandHex": "ab761700"
          },
          {
            "frame": 15,
            "commandHex": "ab760c00"
          }
        ],
        "K_KES_HKS_YA": [
          {
            "frame": 14,
            "commandHex": "ab762600"
          }
        ],
        "K_KES_HKS_YA_M_TSU": [
          {
            "frame": 14,
            "commandHex": "ab762600"
          }
        ],
        "LOW_PU_GAE_ACT_L": [
          {
            "frame": 8,
            "commandHex": "ab762900"
          },
          {
            "frame": 16,
            "commandHex": "ab760800"
          },
          {
            "frame": 16,
            "commandHex": "ab760c00"
          }
        ],
        "LOW_PU_GAE_ACT_MIR_L": [
          {
            "frame": 8,
            "commandHex": "ab762900"
          },
          {
            "frame": 16,
            "commandHex": "ab760800"
          },
          {
            "frame": 16,
            "commandHex": "ab760c00"
          }
        ],
        "LOW_PU_GAE_YA": [
          {
            "frame": 14,
            "commandHex": "ab762600"
          }
        ],
        "LOW_PU_GAE_YA_M_TSU": [
          {
            "frame": 14,
            "commandHex": "ab762600"
          }
        ],
        "MDKICK_GAE_05_ACT_L": [
          {
            "frame": 10,
            "commandHex": "ab762900"
          },
          {
            "frame": 18,
            "commandHex": "ab760800"
          },
          {
            "frame": 18,
            "commandHex": "ab760c00"
          }
        ],
        "MDKICK_GAE_05_YA": [
          {
            "frame": 18,
            "commandHex": "ab762600"
          }
        ],
        "MDLKICK_GAE_01_ACT_L": [
          {
            "frame": 9,
            "commandHex": "ab762900"
          },
          {
            "frame": 19,
            "commandHex": "ab760c00"
          },
          {
            "frame": 19,
            "commandHex": "ab760800"
          }
        ],
        "MDLKICK_GAE_01_YA": [
          {
            "frame": 22,
            "commandHex": "ab762600"
          }
        ],
        "OUT_JU_00": [
          {
            "frame": 8,
            "commandHex": "ab762700"
          }
        ],
        "OUT_JU_UN_00": [
          {
            "frame": 8,
            "commandHex": "ab762700"
          }
        ],
        "PG_NG_MIS_00": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "PRI_DFK_023": [
          {
            "frame": 14,
            "commandHex": "ab761a00"
          }
        ],
        "P_024_KICK_02_ACT_L": [
          {
            "frame": 6,
            "commandHex": "ab762900"
          },
          {
            "frame": 15,
            "commandHex": "ab760800"
          },
          {
            "frame": 15,
            "commandHex": "ab760c00"
          }
        ],
        "P_024_KICK_02_ACT_MIR_L": [
          {
            "frame": 6,
            "commandHex": "ab762900"
          },
          {
            "frame": 15,
            "commandHex": "ab760800"
          },
          {
            "frame": 15,
            "commandHex": "ab760c00"
          }
        ],
        "P_024_KICK_02_YA": [
          {
            "frame": 24,
            "commandHex": "ab762600"
          }
        ],
        "P_024_KICK_02_YA_M_TSU": [
          {
            "frame": 24,
            "commandHex": "ab762600"
          }
        ],
        "RPU_00": [
          {
            "frame": 6,
            "commandHex": "ab761900"
          }
        ],
        "RUF_481_02": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "RUF_481_02_00": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "RUF_491_02": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "RUF_521_02": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "RUF_531_02": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "RUF_551_02": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "SEK_ABK_044_01": [
          {
            "frame": 4,
            "commandHex": "ab761a00"
          }
        ],
        "SEK_ABK_046_02": [
          {
            "frame": 1,
            "commandHex": "ab761a00"
          }
        ],
        "ST_PU_05": [
          {
            "frame": 4,
            "commandHex": "ab761700"
          }
        ],
        "ST_PU_05_M": [
          {
            "frame": 4,
            "commandHex": "ab761700"
          },
          {
            "frame": 4,
            "commandHex": "ab760400"
          }
        ],
        "ST_PU_05_M_VF3": [
          {
            "frame": 4,
            "commandHex": "ab761700"
          }
        ],
        "ST_PU_06_00_WA": [
          {
            "frame": 5,
            "commandHex": "ab761700"
          },
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "ST_PU_06_WA": [
          {
            "frame": 5,
            "commandHex": "ab761700"
          }
        ],
        "SUI_DFP_122_01": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "SUI_DRK_012_01": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "SUI_DRP_092_00": [
          {
            "frame": 5,
            "commandHex": "ab761a00"
          }
        ],
        "SUI_DRP_092_01": [
          {
            "frame": 2,
            "commandHex": "ab761a00"
          }
        ],
        "SUI_DRP_132_02": [
          {
            "frame": 1,
            "commandHex": "ab761900"
          }
        ],
        "SUI_DRP_132_03": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "SUI_JU_KI_00": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "SUI_JU_PU_S_00": [
          {
            "frame": 24,
            "commandHex": "ab760900"
          }
        ],
        "SUI_KI_00": [
          {
            "frame": 4,
            "commandHex": "ab761a00"
          }
        ],
        "TAO_KI_03": [
          {
            "frame": 7,
            "commandHex": "ab761b00"
          }
        ],
        "TAO_KI_04": [
          {
            "frame": 7,
            "commandHex": "ab761b00"
          }
        ],
        "TAO_PU_04_S00": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "TAO_PU_05_S00": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "TAO_PU_06_S00": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "TAO_PU_08_00": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "TAO_PU_09_00": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "TAO_PU_10_00": [
          {
            "frame": 6,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_DASH_TURN_L": [
          {
            "frame": 3,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_DASH_TURN_R": [
          {
            "frame": 3,
            "commandHex": "ab760900"
          }
        ],
        "TA_DOWN_01": [
          {
            "frame": 17,
            "commandHex": "ab762700"
          }
        ],
        "TA_DOWN_03": [
          {
            "frame": 26,
            "commandHex": "ab762700"
          }
        ],
        "TA_DOWN_04": [
          {
            "frame": 26,
            "commandHex": "ab762700"
          }
        ],
        "TA_DOWN_05": [
          {
            "frame": 17,
            "commandHex": "ab762600"
          }
        ],
        "TA_DOWN_B": [
          {
            "frame": 20,
            "commandHex": "ab762700"
          }
        ],
        "TA_DOWN_B_R": [
          {
            "frame": 20,
            "commandHex": "ab762700"
          }
        ],
        "TA_DOWN_B_SY": [
          {
            "frame": 20,
            "commandHex": "ab762700"
          }
        ],
        "TA_JUMP": [
          {
            "frame": 31,
            "commandHex": "ab762a00"
          }
        ],
        "TA_JUMP_S": [
          {
            "frame": 21,
            "commandHex": "ab762a00"
          }
        ],
        "TA_KI_HIZA_L": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "TA_KI_SYO_L": [
          {
            "frame": 5,
            "commandHex": "ab761a00"
          }
        ],
        "TA_KI_SYO_LL": [
          {
            "frame": 5,
            "commandHex": "ab761a00"
          }
        ],
        "TA_RKI_SYO_L": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "TA_SIDE_SI_L_06_3_30": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "TA_SIDE_SI_R_03": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "TA_SIDE_SI_R_112_3_30": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "TD_242": [
          {
            "frame": 10,
            "commandHex": "ab762700"
          }
        ],
        "TD_251": [
          {
            "frame": 10,
            "commandHex": "ab762700"
          }
        ],
        "TD_272": [
          {
            "frame": 14,
            "commandHex": "ab762600"
          }
        ],
        "TD_282": [
          {
            "frame": 10,
            "commandHex": "ab762700"
          }
        ],
        "DMY_DMY_AKI_AKI_URAKEN_ROLL_TOP": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_NGS_SP2_WAK_PED": [
          {
            "frame": 7,
            "commandHex": "ab761b00"
          },
          {
            "frame": 17,
            "commandHex": "ab762d00"
          }
        ],
        "GEN_PED_NGR_SP2_WAK_PED": [
          {
            "frame": 10,
            "commandHex": "ab762d00"
          },
          {
            "frame": 60,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_YAG_ITIMON1_MID_S1_MK": [
          {
            "frame": 3,
            "commandHex": "ab760900"
          },
          {
            "frame": 18,
            "commandHex": "ab761700"
          }
        ],
        "DMY_BA_00": [
          {
            "frame": 6,
            "commandHex": "ab761700"
          }
        ],
        "DMY_JACKY_TA_KI_HIZA_L": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "DMY_JU_KI_SYO_M": [
          {
            "frame": 1,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_NGS_ENSEI_MK": [
          {
            "frame": 1,
            "commandHex": "ab761b00"
          },
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "DMY_AKI_AKI_KICK_BEST": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_CHP_MON_MK": [
          {
            "frame": 16,
            "commandHex": "ab761900"
          },
          {
            "frame": 32,
            "commandHex": "ab761900"
          }
        ],
        "TA_PUKI_01": [
          {
            "frame": 5,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_KICK_BEST_MK": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          },
          {
            "frame": 26,
            "commandHex": "ab761c00"
          }
        ],
        "TA_KI_LOW_03": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "CHA_CHA_NGR_MRK2_CHA": [
          {
            "frame": 20,
            "commandHex": "ab760000"
          },
          {
            "frame": 62,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_DOWN_DROP_B": [
          {
            "frame": 6,
            "commandHex": "ab762800"
          },
          {
            "frame": 16,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_ELB_Y_ROLL_TOP": [
          {
            "frame": 12,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_DOWN_DROP_F": [
          {
            "frame": 7,
            "commandHex": "ab762800"
          },
          {
            "frame": 16,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_DOWN_DROP_R": [
          {
            "frame": 5,
            "commandHex": "ab762800"
          },
          {
            "frame": 17,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_DOWN_DROP_L": [
          {
            "frame": 5,
            "commandHex": "ab762800"
          },
          {
            "frame": 17,
            "commandHex": "ab762700"
          }
        ],
        "KB_TA_DOWN_B_R": [
          {
            "frame": 26,
            "commandHex": "ab762700"
          }
        ],
        "TA_DOWN_WALL_TST_B": [
          {
            "frame": 16,
            "commandHex": "ab762700"
          },
          {
            "frame": 16,
            "commandHex": "ab762700"
          }
        ],
        "TA_DOWN_WALL_BNR": [
          {
            "frame": 19,
            "commandHex": "ab762700"
          }
        ],
        "TA_DOWN_WALL_B_U": [
          {
            "frame": 22,
            "commandHex": "ab762700"
          }
        ],
        "DMY_AKI_AKI_BATTLE_PNC_FUK": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "DMY_AKI_AKI_URAKEN_ROLL_TOP": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "DMY_AKI_AKI_ELBOW": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "DMY_AKI_AKI_BATTLE_PANCH_STR": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_KONGO_TYUKEN_Y_MID": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          },
          {
            "frame": 18,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_CHP_MON": [
          {
            "frame": 16,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_CHP_MON_S1": [
          {
            "frame": 13,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_KICK_BEST": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "DMY_AKI_AKI_NGS_TOP_FLY_L": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "DMY_AKI_AKI_NGS_TOP_FLY_R": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "DMY_AKI_AKI_NGS_MID_TAC_L": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "DMY_AKI_AKI_NGS_MID_TAC_R": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_NGS_SP3_GJJ_CHA": [
          {
            "frame": 8,
            "commandHex": "ab761b00"
          }
        ],
        "CHA_CHA_NGR_SP3_GJJ_CHA": [
          {
            "frame": 34,
            "commandHex": "ab762700"
          },
          {
            "frame": 47,
            "commandHex": "ab762e00"
          }
        ],
        "AKI_AKI_KICK_BEST_S1": [
          {
            "frame": 13,
            "commandHex": "ab761a00"
          },
          {
            "frame": 20,
            "commandHex": "ab762a00"
          }
        ],
        "AKI_AKI_BATTLE_IDO_BACK3": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "DMY_AKI_AKI_CHP_MON": [
          {
            "frame": 16,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_BATTLE_IDO_FRONT3": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_BATTLE_IDO_L": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_BATTLE_IDO_R": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_BATTLE_KICK_LOW": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_BATTLE_KICK_SID": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_BATTLE_KIC_SAC": [
          {
            "frame": 16,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_BATTLE_PANCH_JAB": [
          {
            "frame": 3,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_BATTLE_PANCH_STR": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_BATTLE_PNC_FUK": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_BATTLE_SEIKEN_MID": [
          {
            "frame": 11,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_TUKAMI_HIZA": [
          {
            "frame": 14,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_DOWN_MID1": [
          {
            "frame": 28,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_DOWN_TOP1": [
          {
            "frame": 48,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_TUKAMARE_HIZA_D": [
          {
            "frame": 15,
            "commandHex": "ab760200"
          },
          {
            "frame": 48,
            "commandHex": "ab762700"
          },
          {
            "frame": 64,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_BATTLE_TUKAMI": [
          {
            "frame": 5,
            "commandHex": "ab762f00"
          }
        ],
        "AKI_AKI_BATTLE_TUKAMI_MISS": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_TUKAMI_BODY1": [
          {
            "frame": 13,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_TUKAMI_BODY3_KICK": [
          {
            "frame": 32,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_DOWN_BOT1": [
          {
            "frame": 57,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_TUKAMARE_BODY1": [
          {
            "frame": 14,
            "commandHex": "ab760000"
          },
          {
            "frame": 60,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_TUKAMARE_BODY2": [
          {
            "frame": 5,
            "commandHex": "ab760000"
          }
        ],
        "YKI_AKI_TUKAMARE_BODY3_KICK": [
          {
            "frame": 33,
            "commandHex": "ab760200"
          },
          {
            "frame": 46,
            "commandHex": "ab762600"
          }
        ],
        "AI_FT_NG_041_NA": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "AI_FT_NG_041_YA": [
          {
            "frame": 22,
            "commandHex": "ab760200"
          },
          {
            "frame": 31,
            "commandHex": "ab762700"
          }
        ],
        "AI_PU_H_CHOP_01": [
          {
            "frame": 7,
            "commandHex": "ab761900"
          }
        ],
        "AI_PU_H_CHOP_02": [
          {
            "frame": 10,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_BATTLE_PNC_APR": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_BATTLE_ROLL_KICK_MID": [
          {
            "frame": 8,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_ELBOW": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_HIZA": [
          {
            "frame": 15,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_MAEGERI": [
          {
            "frame": 4,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_BATTLE_CHOPPU": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "TA_NG_IP_NA_WA": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "TA_NG_IP_YA_WA": [
          {
            "frame": 32,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_BOT2": [
          {
            "frame": 8,
            "commandHex": "ab762700"
          },
          {
            "frame": 16,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_TOP2": [
          {
            "frame": 11,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_TOP3": [
          {
            "frame": 18,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_RUN_PUNCH": [
          {
            "frame": 10,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_DOWN_BOT3": [
          {
            "frame": 12,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_BATTLE_KICK_MID": [
          {
            "frame": 11,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_BATTLE_SEIKEN2_MID": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_KICK_BACKROLL_JUMP": [
          {
            "frame": 12,
            "commandHex": "ab761c00"
          },
          {
            "frame": 20,
            "commandHex": "ab762a00"
          }
        ],
        "AKI_AKI_MAWASIGERI_TOP": [
          {
            "frame": 5,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_PANCH_DOWN_MID": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_PANCH_UP_TOP": [
          {
            "frame": 3,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_SIDEKICK_TOP": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_URAKEN_TOP": [
          {
            "frame": 3,
            "commandHex": "ab761900"
          }
        ],
        "JUDO_OG_NA": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "JUDO_OG_YA": [
          {
            "frame": 26,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_NGS_HED_S1_MK": [
          {
            "frame": 9,
            "commandHex": "ab761700"
          },
          {
            "frame": 23,
            "commandHex": "ab761700"
          }
        ],
        "AKI_AKI_NGS_MRK1_MK": [
          {
            "frame": 3,
            "commandHex": "ab761b00"
          },
          {
            "frame": 25,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_NGR_HED_1_NK": [
          {
            "frame": 4,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_BACK_ASIBARAI_BOT": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_BATTLE_KICK_SAC": [
          {
            "frame": 6,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_KICK_ABISEGERI": [
          {
            "frame": 13,
            "commandHex": "ab761a00"
          },
          {
            "frame": 18,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_KICK_BACK_MID": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_TUKAMI_SEOI_NAGE": [
          {
            "frame": 11,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_URAKEN_ROLL_TOP": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_TUKAMI_SEOI_NAGERARE": [
          {
            "frame": 30,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_BATTLE_SEIKEN2_TOP": [
          {
            "frame": 13,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_RUN_KICK": [
          {
            "frame": 13,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_DOWN_BOX_BOT": [
          {
            "frame": 19,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_DOWN_BOX_MID": [
          {
            "frame": 27,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_DOWN_BOX_TOP": [
          {
            "frame": 40,
            "commandHex": "ab762600"
          }
        ],
        "AKI_AKI_BAT_KICK_NIREN1_TOP_MK": [
          {
            "frame": 13,
            "commandHex": "ab761c00"
          },
          {
            "frame": 28,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_KICK_KKT_S1_MK": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          },
          {
            "frame": 21,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_NGS_HED_1_NK": [
          {
            "frame": 1,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_NGS_HED_MK": [
          {
            "frame": 9,
            "commandHex": "ab761700"
          },
          {
            "frame": 23,
            "commandHex": "ab761700"
          }
        ],
        "YKI_AKI_NGR_SP2_WAK": [
          {
            "frame": 10,
            "commandHex": "ab762d00"
          },
          {
            "frame": 60,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_SP3_GJJ": [
          {
            "frame": 34,
            "commandHex": "ab762700"
          },
          {
            "frame": 47,
            "commandHex": "ab762e00"
          }
        ],
        "AKI_AKI_NGS_SP1_ELB": [
          {
            "frame": 10,
            "commandHex": "ab761b00"
          },
          {
            "frame": 16,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_NGS_SP2_WAK": [
          {
            "frame": 7,
            "commandHex": "ab761b00"
          },
          {
            "frame": 17,
            "commandHex": "ab762d00"
          }
        ],
        "AKI_AKI_NGS_SP3_GJJ": [
          {
            "frame": 8,
            "commandHex": "ab761b00"
          }
        ],
        "YKI_AKI_NGR_SP1_ELB": [
          {
            "frame": 16,
            "commandHex": "ab760000"
          },
          {
            "frame": 53,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_FROU": [
          {
            "frame": 13,
            "commandHex": "ab760200"
          },
          {
            "frame": 26,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_HED_2_S1": [
          {
            "frame": 28,
            "commandHex": "ab762700"
          },
          {
            "frame": 38,
            "commandHex": "ab762700"
          }
        ],
        "DMY_TA_NG_IP_NA_WA_FAIL": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "DMY_AKI_AKI_NGS_JUDO_OG_FAIL": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "DMY_AKI_AKI_NGS_YAG_TENTI_FAIL": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_NGS_FROU": [
          {
            "frame": 3,
            "commandHex": "ab761b00"
          },
          {
            "frame": 15,
            "commandHex": "ab761700"
          }
        ],
        "AKI_AKI_NGS_SEOI": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "YKI_AKI_NGR_SEOI": [
          {
            "frame": 33,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_SIDEKICK_TOP_Y": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_NGS_MRK1_CHA": [
          {
            "frame": 3,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_NGS_MRK2_CHA": [
          {
            "frame": 15,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_TB_NGS_BO": [
          {
            "frame": 9,
            "commandHex": "ab761b00"
          }
        ],
        "YKI_JIM_TB_NGR_BO": [
          {
            "frame": 10,
            "commandHex": "ab763000"
          },
          {
            "frame": 25,
            "commandHex": "ab762700"
          },
          {
            "frame": 36,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_MAEGERI_TOP": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_DOWN_SID_L": [
          {
            "frame": 13,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_SID_R": [
          {
            "frame": 10,
            "commandHex": "ab762700"
          },
          {
            "frame": 25,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_SAKE_TOP_R_L": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_TOP_R_R": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_TOP_R_T": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_LOW_L_D": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_LOW_L_L": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_LOW_L_R": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_LOW_R_D": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_LOW_R_L": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_LOW_R_R": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_MID_L_D": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_MID_L_L": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_MID_L_R": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_MID_R_D": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_MID_R_L": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_MID_R_R": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_TOP_L_L": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_TOP_L_R": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_TOP_L_T": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_MOUKO": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          },
          {
            "frame": 16,
            "commandHex": "ab761900"
          },
          {
            "frame": 20,
            "commandHex": "ab761900"
          },
          {
            "frame": 32,
            "commandHex": "ab761700"
          }
        ],
        "AKI_AKI_RIMONT_MID": [
          {
            "frame": 6,
            "commandHex": "ab761700"
          }
        ],
        "AKI_AKI_SAKE_MID_PNC_R_D": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_MID_PNC_R_L": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_MID_PNC_R_R": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "YKI_AKI_MOUKO_YARARE": [
          {
            "frame": 10,
            "commandHex": "ab760c00"
          },
          {
            "frame": 16,
            "commandHex": "ab760c00"
          },
          {
            "frame": 21,
            "commandHex": "ab760c00"
          },
          {
            "frame": 33,
            "commandHex": "ab760200"
          },
          {
            "frame": 43,
            "commandHex": "ab762800"
          }
        ],
        "YKI_AKI_ROLLKICK_TOP_A": [
          {
            "frame": 11,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_ROLLKICK_TOP_B": [
          {
            "frame": 11,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_SAKE_MID_PNC_L_D": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_MID_PNC_L_L": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_MID_PNC_L_R": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_SAKE_TOP_KICK_L_L": [
          {
            "frame": 1,
            "commandHex": "ab761400"
          }
        ],
        "AKI_AKI_SAKE_TOP_KICK_L_R": [
          {
            "frame": 1,
            "commandHex": "ab761400"
          }
        ],
        "AKI_AKI_SAKE_TOP_KICK_L_T": [
          {
            "frame": 1,
            "commandHex": "ab761400"
          }
        ],
        "AKI_AKI_SAKE_TOP_KICK_R_L": [
          {
            "frame": 1,
            "commandHex": "ab761400"
          }
        ],
        "AKI_AKI_SAKE_TOP_KICK_R_R": [
          {
            "frame": 1,
            "commandHex": "ab761400"
          }
        ],
        "AKI_AKI_SAKE_TOP_KICK_R_T": [
          {
            "frame": 1,
            "commandHex": "ab761400"
          }
        ],
        "AKI_AKI_KICK_KERIAGE_Y": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_DASH_L": [
          {
            "frame": 3,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_DASH_R": [
          {
            "frame": 3,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_NAGE_BACK1_BD": [
          {
            "frame": 1,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_NAGE_YOKO1_L": [
          {
            "frame": 23,
            "commandHex": "ab760400"
          }
        ],
        "AKI_AKI_NAGE_YOKO1_R": [
          {
            "frame": 23,
            "commandHex": "ab760400"
          }
        ],
        "YKI_AKI_NAGERARE_BACK1_BD": [
          {
            "frame": 30,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_NAGERARE_YOKO1_L": [
          {
            "frame": 39,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_NAGERARE_YOKO1_R": [
          {
            "frame": 39,
            "commandHex": "ab762600"
          }
        ],
        "AKI_AKI_IDO_FAST_B_L": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_DASH_B": [
          {
            "frame": 3,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_IDO_FAST_F_L": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_DASH_F": [
          {
            "frame": 3,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_KICK_BOX": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_DOWN_BACK_BOT1": [
          {
            "frame": 10,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_BACK_MID1": [
          {
            "frame": 10,
            "commandHex": "ab762700"
          },
          {
            "frame": 31,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_BACK_TOP1": [
          {
            "frame": 12,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_HAGAI_SARE_KERI": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_HAGAI_SARE_NUKE": [
          {
            "frame": 14,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_DOWN_SIDE_L_B": [
          {
            "frame": 13,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_SIDE_L_M": [
          {
            "frame": 27,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_SIDE_L_T": [
          {
            "frame": 17,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_SIDE_R_B": [
          {
            "frame": 13,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_SIDE_R_M": [
          {
            "frame": 44,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_SIDE_R_T": [
          {
            "frame": 15,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_HAGAI_SIME_NUKERARE": [
          {
            "frame": 15,
            "commandHex": "ab760000"
          }
        ],
        "JEF_TA_SU_UPPER": [
          {
            "frame": 7,
            "commandHex": "ab761900"
          }
        ],
        "SUI_PU_FB_01": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "TOU_TFK_222": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_KICK_ZEN": [
          {
            "frame": 5,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_KICK_ZEN_S1": [
          {
            "frame": 5,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_NGS_LOW_L": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_NGS_LOW_R": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_NGS_MID_L": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_NGS_MID_R": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_NGS_TOP_L": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_NGS_TOP_R": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "DMY_AKI_AKI_NGS_MID_L": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "DMY_AKI_AKI_NGS_MID_R": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "DMY_AKI_AKI_NGS_TOP_L": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "DMY_AKI_AKI_NGS_TOP_R": [
          {
            "frame": 1,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_BATTLE_PANCH_FUK_MISS": [
          {
            "frame": 11,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_KICK_BACKROLL_TOP_MISS": [
          {
            "frame": 9,
            "commandHex": "ab761c00"
          }
        ],
        "PAI_LSPIN_KICK": [
          {
            "frame": 6,
            "commandHex": "ab761c00"
          }
        ],
        "SUI_SUFA_191": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "JIJ_KEM_TKK_SEME_ASI_D": [
          {
            "frame": 2,
            "commandHex": "ab761400"
          },
          {
            "frame": 11,
            "commandHex": "ab760c00"
          },
          {
            "frame": 11,
            "commandHex": "ab760800"
          }
        ],
        "AKI_AKI_KICK_BACKROLL_JUMP_S1": [
          {
            "frame": 10,
            "commandHex": "ab761c00"
          },
          {
            "frame": 20,
            "commandHex": "ab762a00"
          }
        ],
        "AKI_AKI_NEWAP": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_NEWAP_S1": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_BATTLE_PANCH_FUC_MISS2": [
          {
            "frame": 11,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_BATTLE_PNC_APR2": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_KICK_SUBERI": [
          {
            "frame": 15,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_KICK_SUBERI_S1": [
          {
            "frame": 11,
            "commandHex": "ab761a00"
          },
          {
            "frame": 21,
            "commandHex": "ab762a00"
          }
        ],
        "AKI_AKI_NGS_BKFRIP": [
          {
            "frame": 4,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_NGS_HED_1": [
          {
            "frame": 7,
            "commandHex": "ab761700"
          }
        ],
        "AKI_AKI_DOWN_BOMBER_L": [
          {
            "frame": 7,
            "commandHex": "ab762800"
          },
          {
            "frame": 18,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_KONGO_TYUKEN_MID": [
          {
            "frame": 6,
            "commandHex": "ab761900"
          },
          {
            "frame": 15,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_NGS_ROKU_KOKKO": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          },
          {
            "frame": 30,
            "commandHex": "ab760200"
          }
        ],
        "AKI_AKI_NGS_ROKU_SYAKO": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          },
          {
            "frame": 16,
            "commandHex": "ab760200"
          }
        ],
        "AKI_AKI_NGS_ROKU_TANHE": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          },
          {
            "frame": 24,
            "commandHex": "ab760200"
          }
        ],
        "YKI_AKI_NGR_ROKU_KOKKO": [
          {
            "frame": 42,
            "commandHex": "ab762700"
          },
          {
            "frame": 72,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_ROKU_SYAKO": [
          {
            "frame": 26,
            "commandHex": "ab762700"
          },
          {
            "frame": 37,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_ROKU_TANHE": [
          {
            "frame": 34,
            "commandHex": "ab762700"
          },
          {
            "frame": 56,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_KONGO_TYUKEN_A_MID": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_KONGO_TYUKEN_B_MID": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "ASHI_00_N_WA": [
          {
            "frame": 1,
            "commandHex": "ab761900"
          }
        ],
        "ASHI_00_Y_WA": [
          {
            "frame": 14,
            "commandHex": "ab761a00"
          },
          {
            "frame": 15,
            "commandHex": "ab760200"
          },
          {
            "frame": 26,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_HKK_SOUTOU_MID": [
          {
            "frame": 20,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_NGS_ROKU_JUNPO": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          },
          {
            "frame": 14,
            "commandHex": "ab760200"
          }
        ],
        "AKI_AKI_NGS_ROKU_KAKUDA": [
          {
            "frame": 6,
            "commandHex": "ab761900"
          },
          {
            "frame": 14,
            "commandHex": "ab761900"
          },
          {
            "frame": 20,
            "commandHex": "ab761900"
          },
          {
            "frame": 30,
            "commandHex": "ab760200"
          },
          {
            "frame": 40,
            "commandHex": "ab761700"
          },
          {
            "frame": 43,
            "commandHex": "ab760200"
          }
        ],
        "AKI_AKI_ROKU_SENHOU_MID": [
          {
            "frame": 10,
            "commandHex": "ab761700"
          }
        ],
        "YKI_AKI_NGR_ROKU_JUNPO": [
          {
            "frame": 26,
            "commandHex": "ab762700"
          },
          {
            "frame": 45,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_ROKU_KAKUDA": [
          {
            "frame": 6,
            "commandHex": "ab760200"
          },
          {
            "frame": 13,
            "commandHex": "ab760200"
          },
          {
            "frame": 20,
            "commandHex": "ab760200"
          },
          {
            "frame": 30,
            "commandHex": "ab760200"
          },
          {
            "frame": 42,
            "commandHex": "ab760200"
          },
          {
            "frame": 52,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_NGS_ENSEI": [
          {
            "frame": 1,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_NGS_INASI": [
          {
            "frame": 1,
            "commandHex": "ab761b00"
          }
        ],
        "YKI_AKI_NGR_ENSEI": [
          {
            "frame": 4,
            "commandHex": "ab760200"
          },
          {
            "frame": 19,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_HAN_TOP": [
          {
            "frame": 20,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_UPR_TOP": [
          {
            "frame": 19,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_BAT_KICK_KKT_TOP": [
          {
            "frame": 14,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_BAT_RUN_ELB_TOP_R": [
          {
            "frame": 7,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_NGS_JUDO_OG": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_NGS_JUDO_TM": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_NGS_YAG_TENTI": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_YAG_ITIMON1_MID": [
          {
            "frame": 3,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_YAG_ITIMON2_MID": [
          {
            "frame": 8,
            "commandHex": "ab761700"
          },
          {
            "frame": 8,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_YAG_SANSEI_MID": [
          {
            "frame": 1,
            "commandHex": "ab760900"
          },
          {
            "frame": 10,
            "commandHex": "ab760900"
          },
          {
            "frame": 15,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_NGR_JUDO_OG": [
          {
            "frame": 26,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_JUDO_TM": [
          {
            "frame": 22,
            "commandHex": "ab760200"
          },
          {
            "frame": 31,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_YAG_TENTI": [
          {
            "frame": 33,
            "commandHex": "ab762700"
          },
          {
            "frame": 34,
            "commandHex": "ab761700"
          },
          {
            "frame": 56,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_BAT_KICK_NIREN1_TOP": [
          {
            "frame": 13,
            "commandHex": "ab761c00"
          },
          {
            "frame": 20,
            "commandHex": "ab762a00"
          }
        ],
        "AKI_AKI_BAT_KICK_NIREN2_TOP": [
          {
            "frame": 6,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_NGS_HED_2": [
          {
            "frame": 7,
            "commandHex": "ab761700"
          }
        ],
        "AKI_AKI_TM_TKL_ELB": [
          {
            "frame": 4,
            "commandHex": "ab761100"
          },
          {
            "frame": 34,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_UDEKIME_L_KICK_B": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_UDEKIME_L_KICK_F": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_UDEKIME_L_KICK_L": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_UDEKIME_L_KICK_R": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_UKRARE_L": [
          {
            "frame": 1,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_UKRARE_L_EN": [
          {
            "frame": 7,
            "commandHex": "ab760000"
          },
          {
            "frame": 24,
            "commandHex": "ab762700"
          },
          {
            "frame": 34,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_IDO_FAST2_B_L": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_IDO_FAST2_B_R": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_IDO_FAST2_F_L": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_IDO_FAST2_F_R": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_TM_NGS_HIJIURA_TOP": [
          {
            "frame": 7,
            "commandHex": "ab761100"
          },
          {
            "frame": 18,
            "commandHex": "ab760200"
          }
        ],
        "AKI_AKI_TTM_NGS_RIMON": [
          {
            "frame": 12,
            "commandHex": "ab760200"
          },
          {
            "frame": 13,
            "commandHex": "ab761700"
          }
        ],
        "YKI_AKI_TM_NGR_HIJIURA_TOP": [
          {
            "frame": 19,
            "commandHex": "ab760000"
          },
          {
            "frame": 33,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_TM_NGR_SUKU": [
          {
            "frame": 30,
            "commandHex": "ab761700"
          },
          {
            "frame": 31,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_TTM_NGR_KCATCH": [
          {
            "frame": 29,
            "commandHex": "ab762600"
          },
          {
            "frame": 30,
            "commandHex": "ab761700"
          }
        ],
        "YKI_AKI_TTM_NGR_KOTE": [
          {
            "frame": 27,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_TTM_NGR_KOTE_M": [
          {
            "frame": 27,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_TTM_NGR_RIMON": [
          {
            "frame": 13,
            "commandHex": "ab761700"
          },
          {
            "frame": 50,
            "commandHex": "ab762600"
          }
        ],
        "AKI_AKI_KATI1": [
          {
            "frame": 6,
            "commandHex": "ab770700"
          },
          {
            "frame": 35,
            "commandHex": "ab770500"
          },
          {
            "frame": 47,
            "commandHex": "ab770500"
          },
          {
            "frame": 83,
            "commandHex": "ab770600"
          }
        ],
        "AKI_AKI_UDEKIME_L_ELB": [
          {
            "frame": 7,
            "commandHex": "ab760000"
          }
        ],
        "AKI_AKI_UDEKIME_L_HIZA": [
          {
            "frame": 10,
            "commandHex": "ab760000"
          }
        ],
        "YKI_AKI_UKRARE_L_ELB": [
          {
            "frame": 18,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_UKRARE_L_HIZA": [
          {
            "frame": 24,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_DOWN_BOX_BOT": [
          {
            "frame": 15,
            "commandHex": "ab762600"
          }
        ],
        "AKI_AKI_SY_PNC_AP_CMB": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_TM_KICK_FUTOU": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          },
          {
            "frame": 16,
            "commandHex": "ab761a00"
          },
          {
            "frame": 29,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_TM_NGS_HIZA_MID": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_TTM_KICK1_MID": [
          {
            "frame": 22,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_TTM_KICK2_TOP": [
          {
            "frame": 4,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_TTM_KICK_MAWASI_TOP": [
          {
            "frame": 9,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_TT_KICK_BACKROLL_TOP": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_TT_YOUSI_MID": [
          {
            "frame": 9,
            "commandHex": "ab761b00"
          }
        ],
        "YKI_AKI_TM_NGR_HIZA_MID": [
          {
            "frame": 9,
            "commandHex": "ab760200"
          },
          {
            "frame": 27,
            "commandHex": "ab762700"
          },
          {
            "frame": 33,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_KICK_ENSEN_TOP": [
          {
            "frame": 5,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_CHP_NUKE_MID": [
          {
            "frame": 13,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_ELB_ROLL_TOP": [
          {
            "frame": 10,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_KICK_DRAGON": [
          {
            "frame": 11,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_NGS_MAKINAGE": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "YKI_AKI_DOWN_FLY_BACK1": [
          {
            "frame": 14,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_FLY_BACK2": [
          {
            "frame": 12,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_FLY_FRONT1": [
          {
            "frame": 17,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_FLY_FRONT2": [
          {
            "frame": 14,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_FLY_SID1_R": [
          {
            "frame": 15,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_DOWN_FLY_SID2_R": [
          {
            "frame": 17,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_MAKINAGE": [
          {
            "frame": 21,
            "commandHex": "ab763000"
          },
          {
            "frame": 32,
            "commandHex": "ab762700"
          },
          {
            "frame": 33,
            "commandHex": "ab761700"
          }
        ],
        "YKI_AKI_TM_KICK_FUTOU_YARA": [
          {
            "frame": 7,
            "commandHex": "ab760000"
          },
          {
            "frame": 17,
            "commandHex": "ab760000"
          },
          {
            "frame": 29,
            "commandHex": "ab760000"
          },
          {
            "frame": 42,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_TTM_KICK1_MID_YARA": [
          {
            "frame": 10,
            "commandHex": "ab761100"
          },
          {
            "frame": 23,
            "commandHex": "ab760000"
          },
          {
            "frame": 37,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_TTM_KICK_MAWASI_YARA": [
          {
            "frame": 10,
            "commandHex": "ab760000"
          },
          {
            "frame": 22,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_TT_KICK_BACKROLL_TOP": [
          {
            "frame": 10,
            "commandHex": "ab760000"
          },
          {
            "frame": 23,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_TT_KICK_GYAKU_YARA": [
          {
            "frame": 10,
            "commandHex": "ab760000"
          },
          {
            "frame": 20,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_TT_YOUSI_MID_YARA": [
          {
            "frame": 11,
            "commandHex": "ab760000"
          },
          {
            "frame": 29,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_ELB_HAZ_TOP": [
          {
            "frame": 10,
            "commandHex": "ab760900"
          },
          {
            "frame": 11,
            "commandHex": "ab762100"
          }
        ],
        "AKI_AKI_KICK_HAZ_KESA_TOP": [
          {
            "frame": 11,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_KICK_HAZ_TOBI_TOP": [
          {
            "frame": 11,
            "commandHex": "ab761c00"
          },
          {
            "frame": 18,
            "commandHex": "ab762a00"
          }
        ],
        "YKI_AKI_NGR_JUDO_OG_FUKU": [
          {
            "frame": 26,
            "commandHex": "ab763000"
          },
          {
            "frame": 38,
            "commandHex": "ab764500"
          }
        ],
        "YKI_AKI_NGR_YAG_TENTI_FUKU": [
          {
            "frame": 31,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_DAMEGE_FLY": [
          {
            "frame": 9,
            "commandHex": "ab762900"
          }
        ],
        "AKI_KIS_KICK_NIKI": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          },
          {
            "frame": 23,
            "commandHex": "ab762a00"
          }
        ],
        "AKI_KIS_KONBI_APR": [
          {
            "frame": 7,
            "commandHex": "ab761900"
          }
        ],
        "AKI_KIS_KONBI_FUK": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "AKI_KIS_KONBI_STR": [
          {
            "frame": 10,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_DOWN_BOMBER_R": [
          {
            "frame": 7,
            "commandHex": "ab762800"
          },
          {
            "frame": 18,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_SY_ABISE_CMB": [
          {
            "frame": 7,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_SY_HARAI_CMB": [
          {
            "frame": 5,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_NGS_JUDO_TM_FUKU": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_OK_AO_KAITEN": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_OK_UTU_KAITEN": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_TTM_NGS_KOTE_FUKU": [
          {
            "frame": 73,
            "commandHex": "ab762600"
          }
        ],
        "AKI_AKI_TTM_NGS_KOTE_M_FUKU": [
          {
            "frame": 73,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_NGR_JUDO_TM_FUKU": [
          {
            "frame": 28,
            "commandHex": "ab763000"
          },
          {
            "frame": 36,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_TM_NGR_SUKU_FUKU": [
          {
            "frame": 28,
            "commandHex": "ab761100"
          },
          {
            "frame": 40,
            "commandHex": "ab761100"
          }
        ],
        "YKI_AKI_TTM_NGR_KOTE_FUKU": [
          {
            "frame": 39,
            "commandHex": "ab761100"
          }
        ],
        "YKI_AKI_TTM_NGR_KOTE_M_FUKU": [
          {
            "frame": 39,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_BATTLE_TUKAMI_ALL": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          },
          {
            "frame": 32,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_DOWN_UKEMI_TOP": [
          {
            "frame": 7,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_NGR_IPPON_UKEMI": [
          {
            "frame": 32,
            "commandHex": "ab761100"
          }
        ],
        "YKI_AKI_BATTLE_TUKAMARE_ALL": [
          {
            "frame": 32,
            "commandHex": "ab760000"
          }
        ],
        "YKI_AKI_NGR_BKFRIP": [
          {
            "frame": 21,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_HED_1": [
          {
            "frame": 8,
            "commandHex": "ab760000"
          },
          {
            "frame": 26,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_NGS_B_HIKI": [
          {
            "frame": 1,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_NGS_CATCH_MKICK_EN": [
          {
            "frame": 11,
            "commandHex": "ab761900"
          },
          {
            "frame": 43,
            "commandHex": "ab761100"
          }
        ],
        "OTH_KIS_NGR_CATCH_MKICK": [
          {
            "frame": 1,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_NGR_CATCH_MKICK_EN": [
          {
            "frame": 15,
            "commandHex": "ab761100"
          },
          {
            "frame": 40,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_NGR_B_HIKI": [
          {
            "frame": 11,
            "commandHex": "ab760200"
          }
        ],
        "YKI_AKI_NGR_HED_2": [
          {
            "frame": 6,
            "commandHex": "ab760000"
          },
          {
            "frame": 16,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_BATTLE_PNC_SHOTEI": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_RUN_KICK_SURA": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_TT_NGR_SINKUU": [
          {
            "frame": 26,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_UKERARE_L_DAM1": [
          {
            "frame": 20,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_NGS_ENSEI_PNC": [
          {
            "frame": 18,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_BEND_DOWN": [
          {
            "frame": 2,
            "commandHex": "ab761e00"
          }
        ],
        "AKI_AKI_TTM_NGS_YAG_SANSEI": [
          {
            "frame": 11,
            "commandHex": "ab760200"
          },
          {
            "frame": 11,
            "commandHex": "ab761700"
          }
        ],
        "YKI_AKI_NGR_ENSEI_PNC": [
          {
            "frame": 5,
            "commandHex": "ab762700"
          },
          {
            "frame": 20,
            "commandHex": "ab760000"
          }
        ],
        "YKI_AKI_TTM_NGR_YAG_SANSEI": [
          {
            "frame": 49,
            "commandHex": "ab762600"
          }
        ],
        "AKI_AKI_DOWN_BOMBER_B": [
          {
            "frame": 4,
            "commandHex": "ab762800"
          }
        ],
        "AKI_AKI_NGS_B_KERI": [
          {
            "frame": 1,
            "commandHex": "ab761b00"
          },
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_SOUSYOU": [
          {
            "frame": 5,
            "commandHex": "ab761700"
          }
        ],
        "AKI_AKI_SY_HARAI": [
          {
            "frame": 5,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_SY_PNC_AP": [
          {
            "frame": 6,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_NGR_B_KERI": [
          {
            "frame": 10,
            "commandHex": "ab760400"
          }
        ],
        "YKI_AKI_TM_TKL_ELB_YARA": [
          {
            "frame": 34,
            "commandHex": "ab760200"
          },
          {
            "frame": 36,
            "commandHex": "ab762700"
          },
          {
            "frame": 49,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_BATTLE_PUNCH_FUK_S1": [
          {
            "frame": 10,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_BATTLE_PNC_SHOTEI_S1": [
          {
            "frame": 9,
            "commandHex": "ab761700"
          },
          {
            "frame": 10,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_BAT_KICK_NIREN1_S1": [
          {
            "frame": 12,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_KICK_ABISEGERI_S1": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          },
          {
            "frame": 18,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_KICK_BACKROLL_S1": [
          {
            "frame": 9,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_KICK_ENSEN1_S1": [
          {
            "frame": 6,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_KICK_ENSEN2_S1": [
          {
            "frame": 1,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_KICK_FUMI": [
          {
            "frame": 11,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_KICK_KERIAGE": [
          {
            "frame": 9,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_KICK_KKT_S1": [
          {
            "frame": 11,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_KONGO_TYUKEN_C_MID": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          },
          {
            "frame": 11,
            "commandHex": "ab761700"
          }
        ],
        "AKI_AKI_LOW_S1": [
          {
            "frame": 4,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_NGS_ENSEI_KKT": [
          {
            "frame": 23,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_RUN_KICK_SURA_S1": [
          {
            "frame": 3,
            "commandHex": "ab761900"
          },
          {
            "frame": 15,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_YAG_ITIMON1_MID_S1": [
          {
            "frame": 3,
            "commandHex": "ab760900"
          }
        ],
        "AKI_AKI_YAG_ITIMON2_MID_S1": [
          {
            "frame": 9,
            "commandHex": "ab761700"
          }
        ],
        "YKI_AKI_NGR_ENSEI_KKT": [
          {
            "frame": 8,
            "commandHex": "ab762700"
          },
          {
            "frame": 23,
            "commandHex": "ab760200"
          }
        ],
        "YKI_AKI_TT_NGR_SINKUU_S1": [
          {
            "frame": 23,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_SY_ABISE": [
          {
            "frame": 7,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_TUKAMI_BODY4": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_TUKAMARE_BODY4": [
          {
            "frame": 6,
            "commandHex": "ab760000"
          },
          {
            "frame": 44,
            "commandHex": "ab762600"
          }
        ],
        "AKI_AKI_COMBO_BDY_ELB": [
          {
            "frame": 10,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_COMBO_JAB_BDY": [
          {
            "frame": 3,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_COMBO_MAWA_2": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_COMBO_MAWA_3": [
          {
            "frame": 14,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_COMBO_URA_LOW": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_COMBO_URA_TTU": [
          {
            "frame": 9,
            "commandHex": "ab761c00"
          },
          {
            "frame": 19,
            "commandHex": "ab762a00"
          }
        ],
        "AKI_AKI_NGS_UCH": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_SY_B_CHOP_01": [
          {
            "frame": 7,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_SY_B_CHOP_02": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_SY_B_KICK_SURI": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_SY_NGS_B_ASB": [
          {
            "frame": 3,
            "commandHex": "ab761b00"
          }
        ],
        "YKI_AKI_NGR_UCH": [
          {
            "frame": 31,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_SY_NGR_B_ASB": [
          {
            "frame": 36,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_SIDEKICK_S1": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_DST_ASI_R": [
          {
            "frame": 12,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_DST_HARA": [
          {
            "frame": 8,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_DST_KIRI": [
          {
            "frame": 16,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_NGS_TM_HZ": [
          {
            "frame": 23,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_TUKAMI_NG": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_NGR_TM_HZ": [
          {
            "frame": 5,
            "commandHex": "ab762700"
          },
          {
            "frame": 23,
            "commandHex": "ab760200"
          }
        ],
        "DMY_AKI_AKI_RIMONT_MID": [
          {
            "frame": 6,
            "commandHex": "ab761700"
          }
        ],
        "AKI_AKI_NGR_UCH_AKI": [
          {
            "frame": 26,
            "commandHex": "ab763000"
          },
          {
            "frame": 35,
            "commandHex": "ab764500"
          }
        ],
        "AKI_AKI_TUKAMI_NG_LONG": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_NGS_UCH_AKI": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_BATTLE_TUKAMI_2": [
          {
            "frame": 5,
            "commandHex": "ab762f00"
          }
        ],
        "AKI_AKI_NGS_SY_NUKI2": [
          {
            "frame": 3,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_NGS_SY_NUKI2_L": [
          {
            "frame": 3,
            "commandHex": "ab761b00"
          }
        ],
        "YKI_AKI_NGR_SY_NUKI1": [
          {
            "frame": 12,
            "commandHex": "ab760000"
          },
          {
            "frame": 48,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_SY_NUKI1_L": [
          {
            "frame": 12,
            "commandHex": "ab760000"
          },
          {
            "frame": 48,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_SY_NUKI2": [
          {
            "frame": 1,
            "commandHex": "ab760000"
          },
          {
            "frame": 25,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_SY_NUKI2_L": [
          {
            "frame": 1,
            "commandHex": "ab760000"
          },
          {
            "frame": 25,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_DOWN_BOMBER": [
          {
            "frame": 5,
            "commandHex": "ab762800"
          },
          {
            "frame": 15,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_NGS_SY_KT1": [
          {
            "frame": 22,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_NGS_SY_KT1_L": [
          {
            "frame": 22,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_NGS_SY_KT2": [
          {
            "frame": 36,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_NGS_SY_KT2_L": [
          {
            "frame": 36,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_NGS_WUDE1": [
          {
            "frame": 27,
            "commandHex": "ab761b00"
          }
        ],
        "YKI_AKI_NGR_SY_KT1": [
          {
            "frame": 31,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_SY_KT1_L": [
          {
            "frame": 31,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_SY_KT2": [
          {
            "frame": 5,
            "commandHex": "ab762700"
          },
          {
            "frame": 36,
            "commandHex": "ab760000"
          }
        ],
        "YKI_AKI_NGR_SY_KT2_L": [
          {
            "frame": 5,
            "commandHex": "ab762700"
          },
          {
            "frame": 36,
            "commandHex": "ab760000"
          }
        ],
        "YKI_AKI_NGR_WUDE1": [
          {
            "frame": 21,
            "commandHex": "ab762d00"
          },
          {
            "frame": 43,
            "commandHex": "ab762e00"
          }
        ],
        "YKI_AKI_NGR_WUDE2": [
          {
            "frame": 19,
            "commandHex": "ab760200"
          }
        ],
        "AKI_AKI_NGS_MRK1": [
          {
            "frame": 3,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_NGS_MRK2": [
          {
            "frame": 20,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_NGR_MRK2": [
          {
            "frame": 20,
            "commandHex": "ab760000"
          },
          {
            "frame": 48,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_COMBO_EL_MA2": [
          {
            "frame": 11,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_KONGO_TYUKEN_Y_A_MID": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_KONGO_TYUKEN_Y_B_MID": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ]
      }
    },
    "battle": {
      "source": "extracted_disc3_v2/data/SCENE/03/MFBT/M_FGT1.BIN",
      "byteLength": 779176,
      "sha256": "c552168abe318805f65a515a5f5c4133bab1c4eb9c74a4c931aa30046bae5ee1",
      "sequences": {
        "AK_SY_PU_SYO_L2": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "ARPD_052_NA_WA": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "ARPD_052_YA": [
          {
            "frame": 12,
            "commandHex": "ab760000"
          },
          {
            "frame": 20,
            "commandHex": "ab762700"
          }
        ],
        "BACK_BL_00_VF3": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "BEAT_NUCKLE_01": [
          {
            "frame": 9,
            "commandHex": "ab760900"
          }
        ],
        "BEAT_NUCKLE_KI": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "DMY_JACKY_HOMING_KI": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "DW_KI_00": [
          {
            "frame": 14,
            "commandHex": "ab761a00"
          }
        ],
        "DW_KI_00_VF3": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "DW_OUTEN_KI_00": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "DW_OUTEN_KI_00_M": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "DW_OUTEN_KI_01": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "DW_OUTEN_KI_01_M": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "DW_TA_KI_00_R": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "DWUN_KI_00_VF3": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "HIZAGERI3_VF2_Y_WA": [
          {
            "frame": 13,
            "commandHex": "ab760000"
          },
          {
            "frame": 14,
            "commandHex": "ab760000"
          },
          {
            "frame": 14,
            "commandHex": "ab760c00"
          },
          {
            "frame": 22,
            "commandHex": "ab760000"
          },
          {
            "frame": 23,
            "commandHex": "ab760000"
          },
          {
            "frame": 23,
            "commandHex": "ab760c00"
          },
          {
            "frame": 35,
            "commandHex": "ab760c00"
          },
          {
            "frame": 35,
            "commandHex": "ab760d00"
          },
          {
            "frame": 39,
            "commandHex": "ab760c00"
          },
          {
            "frame": 39,
            "commandHex": "ab760300"
          },
          {
            "frame": 48,
            "commandHex": "ab762600"
          }
        ],
        "JA_FRKER_SLANT_KI": [
          {
            "frame": 2,
            "commandHex": "ab761c00"
          }
        ],
        "JA_FURIKAERI_SLANT": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "JA_FURIKAERI_URA": [
          {
            "frame": 3,
            "commandHex": "ab761900"
          }
        ],
        "JA_FURIMUKI_URA": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "JA_SEK_DA_061": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "JA_TA_KI_URA_PU": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "JA_TA_SKI_URA": [
          {
            "frame": 3,
            "commandHex": "ab761c00"
          }
        ],
        "JACKY_FRMK_KI": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "JACKY_LITE_KI_01": [
          {
            "frame": 4,
            "commandHex": "ab761a00"
          }
        ],
        "JACKY_LITE_KI_02": [
          {
            "frame": 5,
            "commandHex": "ab761a00"
          }
        ],
        "JACKY_LITE_KI_03": [
          {
            "frame": 4,
            "commandHex": "ab761a00"
          }
        ],
        "JACKY_LITE_KI_04": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "JACKY_LITE_KI_05": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "JACKY_PU_00_VF3": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "JACKY_PU_01_VF3": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "JACKY_PU_11_VF3": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "JACKY_PU_12_VF3": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "JACKY_SIDE_FUCK_KI": [
          {
            "frame": 5,
            "commandHex": "ab761a00"
          }
        ],
        "JACKY_SY_KI_SYO_L": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "JACKY_SY_KI_SYO_L_02": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "JACKY_TA_KI_SYO_L_00": [
          {
            "frame": 5,
            "commandHex": "ab761a00"
          }
        ],
        "JACKY_TA_KI_SYO_M_00": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "JACKY_TA_SY_KI": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "JUS_KI_01": [
          {
            "frame": 5,
            "commandHex": "ab761a00"
          }
        ],
        "JUS_LANDKI_DK": [
          {
            "frame": 4,
            "commandHex": "ab761a00"
          }
        ],
        "JUS_SKI_DK": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "JUS_SY_LANDKI_DK": [
          {
            "frame": 4,
            "commandHex": "ab761a00"
          }
        ],
        "KB_FC_YA": [
          {
            "frame": 30,
            "commandHex": "ab760000"
          },
          {
            "frame": 35,
            "commandHex": "ab760000"
          },
          {
            "frame": 40,
            "commandHex": "ab760000"
          },
          {
            "frame": 45,
            "commandHex": "ab760000"
          },
          {
            "frame": 50,
            "commandHex": "ab760000"
          },
          {
            "frame": 65,
            "commandHex": "ab760200"
          },
          {
            "frame": 99,
            "commandHex": "ab762700"
          }
        ],
        "KICK_02": [
          {
            "frame": 5,
            "commandHex": "ab761a00"
          }
        ],
        "LF_N": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          },
          {
            "frame": 19,
            "commandHex": "ab761a00"
          },
          {
            "frame": 23,
            "commandHex": "ab762b00"
          }
        ],
        "NEEDROP_HIGH_MISS": [
          {
            "frame": 22,
            "commandHex": "ab762600"
          }
        ],
        "NEEDROP_MISS": [
          {
            "frame": 19,
            "commandHex": "ab762600"
          }
        ],
        "NEEDROP_R_HIGH_MISS": [
          {
            "frame": 23,
            "commandHex": "ab762600"
          }
        ],
        "NEEDROP_R_MISS": [
          {
            "frame": 23,
            "commandHex": "ab762600"
          }
        ],
        "PKG_NG_MIS_00": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "RISE_KI_00": [
          {
            "frame": 14,
            "commandHex": "ab761a00"
          }
        ],
        "RISE_KI_00_VF3": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "RISE_KI_02": [
          {
            "frame": 16,
            "commandHex": "ab761a00"
          }
        ],
        "RISE_KI_02_VF3": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "RISE_KIUN_00_VF3": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "RISE_KIUN_02_VF3": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "RPU_00_SY": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "RUF_312": [
          {
            "frame": 15,
            "commandHex": "ab761a00"
          }
        ],
        "RUF_351": [
          {
            "frame": 13,
            "commandHex": "ab761a00"
          }
        ],
        "RUF_452": [
          {
            "frame": 13,
            "commandHex": "ab761a00"
          }
        ],
        "RUF_481_02_00_VF3": [
          {
            "frame": 9,
            "commandHex": "ab761a00"
          }
        ],
        "RUF_541_02": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "SARA_KI_00": [
          {
            "frame": 2,
            "commandHex": "ab761c00"
          }
        ],
        "SARA_KI_01": [
          {
            "frame": 2,
            "commandHex": "ab761c00"
          }
        ],
        "SEK_ABK_026": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "SEK_DA_061": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "SEK_JB_042_SY_TSU": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "SEK_JB_042_TSU": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "SEK_SWPU_012": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "SEK_SWPU_154": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "SJU_PU_ELB": [
          {
            "frame": 18,
            "commandHex": "ab761a00"
          }
        ],
        "SJU_PU_SH": [
          {
            "frame": 13,
            "commandHex": "ab761900"
          }
        ],
        "SKI_URA_00": [
          {
            "frame": 1,
            "commandHex": "ab761c00"
          }
        ],
        "SKI_URA_00_MIR": [
          {
            "frame": 1,
            "commandHex": "ab761c00"
          }
        ],
        "SKI_URA_01": [
          {
            "frame": 2,
            "commandHex": "ab761c00"
          }
        ],
        "SUSO_KI_02_C_12": [
          {
            "frame": 3,
            "commandHex": "ab761900"
          }
        ],
        "TA_2PUKI_00": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "TA_BROLL_S": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          },
          {
            "frame": 14,
            "commandHex": "ab762900"
          },
          {
            "frame": 22,
            "commandHex": "ab762900"
          }
        ],
        "TA_DRAGON_KICK": [
          {
            "frame": 17,
            "commandHex": "ab762b00"
          }
        ],
        "TA_HIJI_PU": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "TA_KI_BROLL": [
          {
            "frame": 2,
            "commandHex": "ab761e00"
          }
        ],
        "TA_KI_SYO_MID": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "TA_KSM_SJKI": [
          {
            "frame": 15,
            "commandHex": "ab761a00"
          }
        ],
        "TA_NG_IP_NA": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "TA_NG_IP_YA": [
          {
            "frame": 30,
            "commandHex": "ab762700"
          }
        ],
        "TA_PUKI_01_00": [
          {
            "frame": 3,
            "commandHex": "ab761a00"
          }
        ],
        "TA_PUNCH_GRE1": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "TA_PUNCH_GRE2": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "TA_RPU_00_SYW": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "TA_RPU_00_VF3": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "TA_RPU_00_W": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "TA_SKI_HIGH": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "TA_SKI_URA_MIR": [
          {
            "frame": 3,
            "commandHex": "ab761c00"
          }
        ],
        "TACKLE_N": [
          {
            "frame": 7,
            "commandHex": "ab761900"
          }
        ],
        "TOU_ROLL_NA": [
          {
            "frame": 7,
            "commandHex": "ab762a00"
          },
          {
            "frame": 26,
            "commandHex": "ab762a00"
          }
        ],
        "TOU_ROLL_YA": [
          {
            "frame": 28,
            "commandHex": "ab762700"
          }
        ],
        "TOU_SDNG_M_YA": [
          {
            "frame": 22,
            "commandHex": "ab760200"
          },
          {
            "frame": 24,
            "commandHex": "ab762600"
          }
        ],
        "TOU_SDNG_YA": [
          {
            "frame": 22,
            "commandHex": "ab760200"
          },
          {
            "frame": 24,
            "commandHex": "ab762600"
          }
        ],
        "VF2_SY_KI_SYO_L": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "WILLIE_PU_00_01": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "WLF_WB_031": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "WOLF_PU_BODY": [
          {
            "frame": 5,
            "commandHex": "ab761f00"
          }
        ],
        "WOLF_SOBAT": [
          {
            "frame": 9,
            "commandHex": "ab761a00"
          },
          {
            "frame": 18,
            "commandHex": "ab762a00"
          }
        ],
        "WOLF_TA_KI_SYO_L_01": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "WOLF_TA_KI_SYO_LL_01": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "WOLF_TA_KI_LOW_03_01": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "HIJI_NOU": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          }
        ],
        "JEFFRY_HIJI12": [
          {
            "frame": 6,
            "commandHex": "ab761900"
          }
        ],
        "JEF_GE_KI_00": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "JEF_KENKA_PU": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "JEF_TACL_NA": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "JEF_WFP_012_VF3": [
          {
            "frame": 12,
            "commandHex": "ab761900"
          }
        ],
        "KICK_00": [
          {
            "frame": 7,
            "commandHex": "ab761b00"
          }
        ],
        "KUMI_RES_ST": [
          {
            "frame": 6,
            "commandHex": "ab761b00"
          }
        ],
        "SARAH_SIDE_FUCK_KI": [
          {
            "frame": 5,
            "commandHex": "ab761a00"
          }
        ],
        "TA_BS_NAGE2": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "TA_ROBO_PU00": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "TA_ROBO_PU01": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "TA_ROBO_PU02": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "WILLIE_PU_01_01_VF3": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "WILLIE_PU_03_01_VF3": [
          {
            "frame": 5,
            "commandHex": "ab761900"
          }
        ],
        "WILLIE_PU_09_WA": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "WOLF_PU_01_01_VF3": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "WOLF_PU_03_01_VF3": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "WOLF_PU_09_WA": [
          {
            "frame": 7,
            "commandHex": "ab761900"
          }
        ],
        "WOLF_PU_BODY_01": [
          {
            "frame": 7,
            "commandHex": "ab761900"
          }
        ],
        "WOLF_PU_BODY_02": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "WOLF_PU_SYGAME": [
          {
            "frame": 6,
            "commandHex": "ab761900"
          }
        ],
        "WOLF_SY_KI_SYO_L_VF3": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "TA_BS_YARARE2": [
          {
            "frame": 58,
            "commandHex": "ab762700"
          },
          {
            "frame": 116,
            "commandHex": "ab762700"
          }
        ],
        "JEF_TACL_YA": [
          {
            "frame": 18,
            "commandHex": "ab762700"
          },
          {
            "frame": 22,
            "commandHex": "ab760200"
          },
          {
            "frame": 31,
            "commandHex": "ab762700"
          }
        ],
        "JEF_HIJI": [
          {
            "frame": 6,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_K2_KICK_LOW": [
          {
            "frame": 15,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_K2_KICK_SID": [
          {
            "frame": 13,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_K2_PNC_FUK": [
          {
            "frame": 17,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_K2_PNC_JUB": [
          {
            "frame": 15,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_K2_PNC_TOP": [
          {
            "frame": 15,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_K4_KICK_ENG": [
          {
            "frame": 12,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_K4_KICK_LOW": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_K4_KICK_MID": [
          {
            "frame": 11,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_K4_PNC_JUB": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_K4_PNC_TOP": [
          {
            "frame": 15,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_K3_KICK_SDK_MID": [
          {
            "frame": 18,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_K3_KICK_TOP": [
          {
            "frame": 16,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_K3_PNC_JUB": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_K3_PNC_STR_TOP": [
          {
            "frame": 8,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_K3_SOBAT_MID": [
          {
            "frame": 16,
            "commandHex": "ab761a00"
          },
          {
            "frame": 18,
            "commandHex": "ab762a00"
          }
        ],
        "AKI_AKI_DNGR_UMA_YARARE": [
          {
            "frame": 22,
            "commandHex": "ab760000"
          },
          {
            "frame": 45,
            "commandHex": "ab760000"
          },
          {
            "frame": 63,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_NGR_SABA": [
          {
            "frame": 41,
            "commandHex": "ab760000"
          },
          {
            "frame": 64,
            "commandHex": "ab762700"
          }
        ],
        "BIG_TOG_CHP_MON_TOP": [
          {
            "frame": 12,
            "commandHex": "ab761900"
          },
          {
            "frame": 13,
            "commandHex": "ab761700"
          }
        ],
        "BIG_TOG_DNGS_UMA_SEME": [
          {
            "frame": 5,
            "commandHex": "ab761700"
          },
          {
            "frame": 20,
            "commandHex": "ab761900"
          },
          {
            "frame": 42,
            "commandHex": "ab761900"
          },
          {
            "frame": 64,
            "commandHex": "ab760200"
          }
        ],
        "BIG_TOG_HAN_S_MID": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          },
          {
            "frame": 12,
            "commandHex": "ab761700"
          }
        ],
        "BIG_TOG_HAN_W_MID": [
          {
            "frame": 24,
            "commandHex": "ab761900"
          },
          {
            "frame": 25,
            "commandHex": "ab761700"
          }
        ],
        "BIG_TOG_NGS_SABA": [
          {
            "frame": 6,
            "commandHex": "ab761700"
          },
          {
            "frame": 41,
            "commandHex": "ab760200"
          }
        ],
        "BIG_TOG_HAN_S1_MID": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          },
          {
            "frame": 11,
            "commandHex": "ab761700"
          }
        ],
        "BIG_TOG_HAN_S2_MID": [
          {
            "frame": 12,
            "commandHex": "ab761900"
          },
          {
            "frame": 15,
            "commandHex": "ab761700"
          }
        ],
        "BIG_TOG_RUN_R_LP": [
          {
            "frame": 6,
            "commandHex": "ab761700"
          },
          {
            "frame": 24,
            "commandHex": "ab761700"
          }
        ],
        "BIG_TOG_BAT_RUN_R_STOP": [
          {
            "frame": 4,
            "commandHex": "ab761700"
          }
        ],
        "BIG_TOG_RUN_L_LP": [
          {
            "frame": 6,
            "commandHex": "ab761700"
          },
          {
            "frame": 24,
            "commandHex": "ab761700"
          }
        ],
        "BIG_TOG_BAT_RUN_L_STOP": [
          {
            "frame": 6,
            "commandHex": "ab761700"
          }
        ],
        "YKI_AKI_BAT_JUMP_KONTENA": [
          {
            "frame": 30,
            "commandHex": "ab762b00"
          }
        ],
        "AKI_AKI_NGR_TOG_HD": [
          {
            "frame": 97,
            "commandHex": "ab762700"
          }
        ],
        "BIG_TOG_NGS_HD": [
          {
            "frame": 3,
            "commandHex": "ab761b00"
          }
        ],
        "AKI_AKI_NGR_ZUTUKI": [
          {
            "frame": 34,
            "commandHex": "ab760200"
          }
        ],
        "YKI_AKI_K1_KICK_YAKUZA_MID": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_NGS_ZUTUKI": [
          {
            "frame": 3,
            "commandHex": "ab761b00"
          },
          {
            "frame": 35,
            "commandHex": "ab760200"
          }
        ],
        "YKI_AKI_SYADO1_JUB_TOP": [
          {
            "frame": 12,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_SYADO2_JUB2_TOP": [
          {
            "frame": 10,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_SYADO3_BODY_MID": [
          {
            "frame": 12,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_SYADO4_UPC_TOP": [
          {
            "frame": 12,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_NGR_TAKKULE": [
          {
            "frame": 21,
            "commandHex": "ab760000"
          },
          {
            "frame": 65,
            "commandHex": "ab760000"
          },
          {
            "frame": 87,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_NGS_TAKKULE": [
          {
            "frame": 53,
            "commandHex": "ab761900"
          },
          {
            "frame": 66,
            "commandHex": "ab761900"
          },
          {
            "frame": 84,
            "commandHex": "ab760200"
          }
        ],
        "YKI_AKI_KICK_SOBA_MID": [
          {
            "frame": 13,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_RUN_KICK2_DRAGON": [
          {
            "frame": 11,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_IDO_B_BAKTYU": [
          {
            "frame": 15,
            "commandHex": "ab761100"
          }
        ],
        "OTH_KIS_IDO_B_BAKUTEN": [
          {
            "frame": 13,
            "commandHex": "ab761100"
          },
          {
            "frame": 23,
            "commandHex": "ab761100"
          }
        ],
        "OTH_KIS_KESA_MID": [
          {
            "frame": 18,
            "commandHex": "ab761900"
          }
        ],
        "OTH_KIS_KICK_SENPUU_TOP": [
          {
            "frame": 13,
            "commandHex": "ab761c00"
          }
        ],
        "OTH_KIS_RIEN_TOP": [
          {
            "frame": 13,
            "commandHex": "ab761900"
          }
        ],
        "OTH_KIS_URAKEN_TOP": [
          {
            "frame": 14,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_NGR_PDNK": [
          {
            "frame": 14,
            "commandHex": "ab760200"
          },
          {
            "frame": 23,
            "commandHex": "ab760200"
          },
          {
            "frame": 52,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_KAE_RP_TOP": [
          {
            "frame": 34,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_NGR_KAE_LK_TOP": [
          {
            "frame": 12,
            "commandHex": "ab760200"
          },
          {
            "frame": 25,
            "commandHex": "ab762700"
          }
        ],
        "OTH_KIS_IDO_FAST": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "OTH_KIS_KICK_BACK": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_PNC_URA_BOT": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "OTH_KIS_NGS_KAE_RP_TOP": [
          {
            "frame": 4,
            "commandHex": "ab761b00"
          }
        ],
        "OTH_KIS_NGS_KAE_LK_TOP": [
          {
            "frame": 12,
            "commandHex": "ab761c00"
          }
        ],
        "YKI_AKI_KICK_NIDAN_A": [
          {
            "frame": 6,
            "commandHex": "ab761c00"
          }
        ],
        "YKI_AKI_KICK_NIDAN_B": [
          {
            "frame": 4,
            "commandHex": "ab761c00"
          }
        ],
        "YKI_AKI_PNC_APR_SYOU": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "YKI_TER_KICK_LOW": [
          {
            "frame": 9,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_TER_NGS_PDNK": [
          {
            "frame": 14,
            "commandHex": "ab761a00"
          },
          {
            "frame": 24,
            "commandHex": "ab761900"
          }
        ],
        "OTH_KIS_KICK_BACKROLL_JUMP": [
          {
            "frame": 12,
            "commandHex": "ab761c00"
          }
        ],
        "OTH_KIS_KICK_BACKROLL_MID": [
          {
            "frame": 8,
            "commandHex": "ab761c00"
          }
        ],
        "OTH_KIS_NGS_B_NOBOGERI": [
          {
            "frame": 26,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_NGS_F_KICK": [
          {
            "frame": 8,
            "commandHex": "ab761a00"
          },
          {
            "frame": 16,
            "commandHex": "ab761a00"
          },
          {
            "frame": 24,
            "commandHex": "ab761a00"
          },
          {
            "frame": 36,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_NGS_SIDE_L": [
          {
            "frame": 27,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_NGS_SIDE_R": [
          {
            "frame": 27,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_SIDEKICK_TOP": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_NGS_KAE_RP_MID": [
          {
            "frame": 10,
            "commandHex": "ab760200"
          }
        ],
        "OTH_KIS_NGS_KAE_LP_TOP": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_NGR_B_NOBOGERI": [
          {
            "frame": 27,
            "commandHex": "ab760200"
          },
          {
            "frame": 51,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_F_KICK": [
          {
            "frame": 8,
            "commandHex": "ab760200"
          },
          {
            "frame": 16,
            "commandHex": "ab760200"
          },
          {
            "frame": 24,
            "commandHex": "ab760200"
          },
          {
            "frame": 36,
            "commandHex": "ab760200"
          },
          {
            "frame": 50,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_SIDE_L": [
          {
            "frame": 29,
            "commandHex": "ab760200"
          },
          {
            "frame": 51,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_SIDE_R": [
          {
            "frame": 29,
            "commandHex": "ab760200"
          },
          {
            "frame": 51,
            "commandHex": "ab762700"
          }
        ],
        "YKI_AKI_NGR_KAE_RP_MID": [
          {
            "frame": 27,
            "commandHex": "ab762600"
          }
        ],
        "YKI_AKI_NGR_KAE_LP_TOP": [
          {
            "frame": 11,
            "commandHex": "ab760200"
          },
          {
            "frame": 26,
            "commandHex": "ab762600"
          }
        ],
        "OTH_KIS_KICK_KOUSOU": [
          {
            "frame": 6,
            "commandHex": "ab761c00"
          }
        ],
        "OTH_KIS_RUN_KICK_DRAGON": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_K2_CHOP": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_K4_COMB1_FC": [
          {
            "frame": 11,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_K4_KOMB2_BC": [
          {
            "frame": 10,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_K4_TAC_SLOW": [
          {
            "frame": 10,
            "commandHex": "ab761c00"
          }
        ],
        "YKI_AKI_K5_KICK_STP_MID": [
          {
            "frame": 14,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_K5_PNC_BACK_KNC": [
          {
            "frame": 10,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_K5_PNC_SYOTE": [
          {
            "frame": 13,
            "commandHex": "ab760900"
          }
        ],
        "YKI_AKI_K5_RENKERI_1": [
          {
            "frame": 14,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_K5_RENKERI_2": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_JIM_BO_AT1_TOP": [
          {
            "frame": 10,
            "commandHex": "ab761c00"
          }
        ],
        "YKI_JIM_BO_AT2_MID": [
          {
            "frame": 15,
            "commandHex": "ab761c00"
          }
        ],
        "OTH_KIS_MAWASIGERI": [
          {
            "frame": 6,
            "commandHex": "ab761c00"
          }
        ],
        "OTH_KIS_MAWA_FAKE": [
          {
            "frame": 8,
            "commandHex": "ab761c00"
          }
        ],
        "OTH_KIS_NGS_F_KICK_HANG": [
          {
            "frame": 4,
            "commandHex": "ab761b00"
          }
        ],
        "YKI_AKI_NGR_F_KICK_HANG": [
          {
            "frame": 10,
            "commandHex": "ab760200"
          },
          {
            "frame": 19,
            "commandHex": "ab762700"
          },
          {
            "frame": 37,
            "commandHex": "ab762700"
          }
        ],
        "YKI_JIM_BO_AT1_TOP_L": [
          {
            "frame": 11,
            "commandHex": "ab761900"
          }
        ],
        "YKI_JIM_BO_AT1_TOP_RL": [
          {
            "frame": 15,
            "commandHex": "ab761900"
          }
        ],
        "YKI_JIM_BO_AT2_MID_L": [
          {
            "frame": 12,
            "commandHex": "ab761900"
          }
        ],
        "YKI_JIM_BO_AT2_MID_RL": [
          {
            "frame": 16,
            "commandHex": "ab761900"
          }
        ],
        "OTH_KIS_KICK_BACKROLL_JUMP_S": [
          {
            "frame": 9,
            "commandHex": "ab761c00"
          }
        ],
        "YKI_AKI_K4_KICK_FUMI": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_JIM_BO_AT_MID_R": [
          {
            "frame": 12,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K1_JEF_WFP_012_VF3": [
          {
            "frame": 14,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K1_KICK_00": [
          {
            "frame": 14,
            "commandHex": "ab761b00"
          }
        ],
        "YKI_K1_WOLF_PU_01_01_VF3": [
          {
            "frame": 14,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K1_WOLF_PU_03_01_VF3": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K1_WOLF_PU_09_WA": [
          {
            "frame": 11,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K1_WOLF_TA_KI_LOW_03_01": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_K2_JACKY_TA_KI_SYO_L_00": [
          {
            "frame": 14,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_K2_JACKY_TA_KI_SYO_M_00": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_K2_WOLF_PU_SYGAME": [
          {
            "frame": 14,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K3_JAKKY_PU_01_VF3": [
          {
            "frame": 15,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K3_JAKKY_PU_11_VF3": [
          {
            "frame": 13,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K3_JAKKY_PU_12_VF3": [
          {
            "frame": 10,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K3_JEF_KENKA_PU": [
          {
            "frame": 15,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K4_HIJI_NOU": [
          {
            "frame": 14,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_K4_JEFFRY_HIJI12": [
          {
            "frame": 11,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K4_WOLF_PU_BODY_01": [
          {
            "frame": 11,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K4_WOLF_PU_BODY_02": [
          {
            "frame": 12,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K5_SEK_SWPU_012": [
          {
            "frame": 14,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K5_TA_HIJI_PU": [
          {
            "frame": 9,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K5_TA_PUKI_01": [
          {
            "frame": 10,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_K5_TA_PUNCH_GRE2": [
          {
            "frame": 14,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K5_VF2_SY_KI_SYO_L": [
          {
            "frame": 14,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_K1_JEF_GE_KI_00": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_K3_SEK_SWPU_154": [
          {
            "frame": 14,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K5_WOLF_TA_KI_SYO_L_01": [
          {
            "frame": 15,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_NGR_MANJI": [
          {
            "frame": 56,
            "commandHex": "ab760000"
          },
          {
            "frame": 77,
            "commandHex": "ab762d00"
          },
          {
            "frame": 122,
            "commandHex": "ab763100"
          }
        ],
        "OTH_KIS_PU_01": [
          {
            "frame": 4,
            "commandHex": "ab761900"
          }
        ],
        "OTH_KIS_PU_02": [
          {
            "frame": 6,
            "commandHex": "ab761900"
          }
        ],
        "OTH_KIS_PU_03": [
          {
            "frame": 10,
            "commandHex": "ab761900"
          }
        ],
        "GEN_PED_DROP_SEIKOU": [
          {
            "frame": 10,
            "commandHex": "ab762700"
          }
        ],
        "GEN_PED_DROP_SIPPAI": [
          {
            "frame": 13,
            "commandHex": "ab761a00"
          },
          {
            "frame": 23,
            "commandHex": "ab762700"
          }
        ],
        "GEN_PED_NGS_MANJI": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "OTH_KIS_DST_APR": [
          {
            "frame": 17,
            "commandHex": "ab762700"
          }
        ],
        "OTH_KIS_DST_ASI_R": [
          {
            "frame": 12,
            "commandHex": "ab762700"
          }
        ],
        "OTH_KIS_DST_HARA": [
          {
            "frame": 9,
            "commandHex": "ab762700"
          }
        ],
        "OTH_KIS_DST_KIRI": [
          {
            "frame": 16,
            "commandHex": "ab762700"
          }
        ],
        "OTH_KIS_KI_01": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_PU_MD": [
          {
            "frame": 7,
            "commandHex": "ab761900"
          }
        ],
        "OTH_KIS_NGS_MISS": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_K1_KICK_TOP": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_KI_SPIN_HI": [
          {
            "frame": 11,
            "commandHex": "ab761c00"
          }
        ],
        "OTH_KIS_JUMP_KI": [
          {
            "frame": 6,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_KI_SPIN_HI_02": [
          {
            "frame": 9,
            "commandHex": "ab761c00"
          }
        ],
        "OTH_KIS_KI_BACKSPIN": [
          {
            "frame": 6,
            "commandHex": "ab761c00"
          }
        ],
        "OTH_KIS_SOBAT": [
          {
            "frame": 7,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_KI_SPIN_LW": [
          {
            "frame": 6,
            "commandHex": "ab761c00"
          }
        ],
        "AKI_AKI_NGR_FN2": [
          {
            "frame": 44,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_NGS_BTTALK_A": [
          {
            "frame": 18,
            "commandHex": "ab761100"
          },
          {
            "frame": 152,
            "commandHex": "ab761a00"
          },
          {
            "frame": 208,
            "commandHex": "ab761100"
          }
        ],
        "AKI_AKI_NGS_BTTALK_B": [
          {
            "frame": 30,
            "commandHex": "ab761100"
          },
          {
            "frame": 39,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_NGS_BTTALK_C": [
          {
            "frame": 21,
            "commandHex": "ab761100"
          },
          {
            "frame": 33,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_NGS_BTTALK_D": [
          {
            "frame": 25,
            "commandHex": "ab761100"
          },
          {
            "frame": 110,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_NGS_BTTALK_E": [
          {
            "frame": 22,
            "commandHex": "ab761100"
          },
          {
            "frame": 36,
            "commandHex": "ab761900"
          }
        ],
        "GEN_PED_NGS_FN2": [
          {
            "frame": 3,
            "commandHex": "ab761b00"
          },
          {
            "frame": 45,
            "commandHex": "ab762700"
          }
        ],
        "OTH_KIS_NGR_BTTALK_A": [
          {
            "frame": 11,
            "commandHex": "ab761a00"
          },
          {
            "frame": 151,
            "commandHex": "ab761100"
          },
          {
            "frame": 224,
            "commandHex": "ab762a00"
          }
        ],
        "OTH_KIS_NGR_BTTALK_B": [
          {
            "frame": 19,
            "commandHex": "ab761900"
          },
          {
            "frame": 44,
            "commandHex": "ab761100"
          },
          {
            "frame": 342,
            "commandHex": "ab761c00"
          }
        ],
        "OTH_KIS_NGR_BTTALK_C": [
          {
            "frame": 7,
            "commandHex": "ab761900"
          },
          {
            "frame": 299,
            "commandHex": "ab761100"
          },
          {
            "frame": 313,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_NGR_BTTALK_D": [
          {
            "frame": 17,
            "commandHex": "ab761a00"
          },
          {
            "frame": 110,
            "commandHex": "ab761100"
          },
          {
            "frame": 176,
            "commandHex": "ab761a00"
          },
          {
            "frame": 187,
            "commandHex": "ab762a00"
          }
        ],
        "OTH_KIS_NGR_BTTALK_E": [
          {
            "frame": 15,
            "commandHex": "ab761a00"
          },
          {
            "frame": 49,
            "commandHex": "ab761100"
          },
          {
            "frame": 370,
            "commandHex": "ab761a00"
          },
          {
            "frame": 381,
            "commandHex": "ab762a00"
          }
        ],
        "OTH_KIS_NGS_URASEOI2": [
          {
            "frame": 5,
            "commandHex": "ab761b00"
          }
        ],
        "YKI_AKI_K8_MKICK": [
          {
            "frame": 13,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_K8_PNC": [
          {
            "frame": 19,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_NGR_URASEOI2": [
          {
            "frame": 33,
            "commandHex": "ab762700"
          }
        ],
        "OTH_KIS_KI_BACK": [
          {
            "frame": 5,
            "commandHex": "ab761a00"
          }
        ],
        "AKI_AKI_K8_NGR_HEAD": [
          {
            "frame": 32,
            "commandHex": "ab760200"
          },
          {
            "frame": 52,
            "commandHex": "ab760200"
          },
          {
            "frame": 62,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_NGS_BTTALK_F": [
          {
            "frame": 17,
            "commandHex": "ab761a00"
          },
          {
            "frame": 40,
            "commandHex": "ab761a00"
          },
          {
            "frame": 62,
            "commandHex": "ab761900"
          }
        ],
        "OTH_KIS_JUMP_KI_BACKSPIN": [
          {
            "frame": 14,
            "commandHex": "ab761c00"
          }
        ],
        "OTH_KIS_NGR_BTTALK_F": [
          {
            "frame": 17,
            "commandHex": "ab761a00"
          },
          {
            "frame": 40,
            "commandHex": "ab761a00"
          },
          {
            "frame": 62,
            "commandHex": "ab761900"
          }
        ],
        "YKI_AKI_K8_NGS_HEAD": [
          {
            "frame": 31,
            "commandHex": "ab761900"
          },
          {
            "frame": 52,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_PU_BACK": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "OTH_KIS_RUN_KICK": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          }
        ],
        "GEN_PED_BACKKICK": [
          {
            "frame": 15,
            "commandHex": "ab761a00"
          }
        ],
        "GEN_PED_CHP_ROLL": [
          {
            "frame": 15,
            "commandHex": "ab761900"
          }
        ],
        "GEN_PED_TAC": [
          {
            "frame": 13,
            "commandHex": "ab761c00"
          }
        ],
        "GEN_PED_TUKI": [
          {
            "frame": 17,
            "commandHex": "ab760900"
          }
        ],
        "OTH_NGT_K6_KICK_HIGH": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_NGT_K6_KICK_LOW": [
          {
            "frame": 9,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_NGT_K6_MAEGERI": [
          {
            "frame": 12,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_DASH_B": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "OTH_KIS_DASH_F": [
          {
            "frame": 5,
            "commandHex": "ab760900"
          }
        ],
        "OTH_KIS_ESCAPE": [
          {
            "frame": 20,
            "commandHex": "ab761900"
          }
        ],
        "GEN_PED_KKT": [
          {
            "frame": 14,
            "commandHex": "ab761a00"
          }
        ],
        "GEN_PED_ROLL_KKT": [
          {
            "frame": 11,
            "commandHex": "ab761a00"
          }
        ],
        "OTH_KIS_BACK_ROLL": [
          {
            "frame": 12,
            "commandHex": "ab761100"
          },
          {
            "frame": 23,
            "commandHex": "ab761100"
          }
        ],
        "OTH_KIS_JUMP_BACK_ROLL": [
          {
            "frame": 17,
            "commandHex": "ab761100"
          }
        ],
        "YKI_JIM_BO_BACKROLL": [
          {
            "frame": 8,
            "commandHex": "ab761c00"
          }
        ],
        "YKI_JIM_BO_TUKI": [
          {
            "frame": 10,
            "commandHex": "ab761900"
          }
        ],
        "OTH_KIS_NGS_B_KAKATO": [
          {
            "frame": 5,
            "commandHex": "ab762a00"
          },
          {
            "frame": 10,
            "commandHex": "ab762a00"
          },
          {
            "frame": 26,
            "commandHex": "ab761a00"
          },
          {
            "frame": 29,
            "commandHex": "ab762a00"
          }
        ],
        "YKI_AKI_NGR_B_KAKATO": [
          {
            "frame": 27,
            "commandHex": "ab760200"
          },
          {
            "frame": 46,
            "commandHex": "ab762700"
          }
        ],
        "AKI_AKI_NGR_BKFRIP": [
          {
            "frame": 58,
            "commandHex": "ab762700"
          }
        ],
        "GEN_PED_NGS_BKFRIP": [
          {
            "frame": 4,
            "commandHex": "ab761b00"
          }
        ],
        "YKI_AKI_K4_KICK_KENKA": [
          {
            "frame": 14,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_K9_NGS_HEAD": [
          {
            "frame": 32,
            "commandHex": "ab761900"
          },
          {
            "frame": 53,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_K9_KICK_KENKA": [
          {
            "frame": 19,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_K9_PNC_TAMEST": [
          {
            "frame": 38,
            "commandHex": "ab761900"
          }
        ],
        "GEN_PED_K7_WOLF_TA_SYO_L_01": [
          {
            "frame": 15,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_K8_KETAGURI": [
          {
            "frame": 16,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_K6_SEK_SWPU_012": [
          {
            "frame": 13,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K6_WOLF_PU_BODY_01": [
          {
            "frame": 11,
            "commandHex": "ab761900"
          }
        ],
        "YKI_K6_WOLF_PU_BODY_02": [
          {
            "frame": 12,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_K3_NGR_HIZAGERI": [
          {
            "frame": 33,
            "commandHex": "ab760200"
          },
          {
            "frame": 49,
            "commandHex": "ab762700"
          }
        ],
        "OTH_KIS_K3_NGS_HIZAGERI": [
          {
            "frame": 1,
            "commandHex": "ab761b00"
          },
          {
            "frame": 32,
            "commandHex": "ab761a00"
          }
        ],
        "GEN_PED_NGS_MANJI_NK": [
          {
            "frame": 28,
            "commandHex": "ab762700"
          }
        ],
        "OTH_KIS_NGS_F_KICK_NK": [
          {
            "frame": 2,
            "commandHex": "ab761a00"
          }
        ],
        "YKI_AKI_NGR_F_KICK_NK": [
          {
            "frame": 1,
            "commandHex": "ab760900"
          },
          {
            "frame": 10,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_K3_NGR_HIZAGERI_NK": [
          {
            "frame": 15,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_K8_NGR_HEAD_NK": [
          {
            "frame": 19,
            "commandHex": "ab761900"
          }
        ],
        "AKI_AKI_NGR_BKFRIP_NK": [
          {
            "frame": 20,
            "commandHex": "ab762a00"
          }
        ],
        "AKI_AKI_NGR_FN2_NK": [
          {
            "frame": 20,
            "commandHex": "ab762a00"
          }
        ],
        "OTH_KIS_K3_NGS_HIZAGERI_NK": [
          {
            "frame": 16,
            "commandHex": "ab760000"
          }
        ],
        "YKI_AKI_K9_NGS_HEAD_NK": [
          {
            "frame": 20,
            "commandHex": "ab760000"
          }
        ],
        "AKI_AKI_NGR_PDNK_NK": [
          {
            "frame": 4,
            "commandHex": "ab761100"
          }
        ]
      }
    }
  }
});
